var t = new Date();
var currentDay = t.getDate();
var currentMonth = t.getMonth();
var currentyear = t.getFullYear();
var weekDay = t.getDay();
var currentHour = t.getHours()

// continuosly check if the fields are completed
document.addEventListener('crPickupActivated', function (e) { 
    console.log('____ activated _____');
    jqCR('#check_template--22526346953025__main-cart').click()
    disableCheckoutButton2();
    var tt = setInterval(function(){
      disableCheckoutButton2();
      //console.log('check.............')
      var fieldsCorrect = checkPickupFields();
      //console.log({fieldsCorrect})
      if (fieldsCorrect === true) {
        //clearInterval(tt);  
      }
      
    }, 1000);
    //setTimeout(function() { clearInterval(tt); }, 5000);  

  jqCR('#pickup-date-start, #note-pickup-date, #pickup-first-name, #pickup-last-name, #pickup-number').on('mouseout keyup change', function(){
  	//console.log('check for others and activate checkout')  	
    checkPickupFields()
  })
  
  jqCR(document).on('change', '#pickup-selected-store', function(){checkPickupFields()})  
  trackChange(jqCR("#pickup-selected-store")[0] );  

   jqCR(document).on('change', '#note-pickup-date', function(){checkPickupFields()})  
   trackChange(jqCR("#note-pickup-date")[0] );
});


MutationObserver = window.MutationObserver || window.WebKitMutationObserver;

var trackChange = function(element) {
  var observer = new MutationObserver(function(mutations, observer) {
    if(mutations[0].attributeName == "value") {
        jqCR(element).trigger("change");
    }
  });
  observer.observe(element, {
    attributes: true
  });
}

function checkPickupFields(){
  	var pickupDate = jqCR('#pickup-date-start').val();
    var firstName = jqCR('#pickup-first-name').val();
    var lastName = jqCR('#pickup-last-name').val();
    var phone = jqCR('#pickup-number').val();
    var selectedStoreId = jqCR('#pickup-selected-store-id').val()
    if (pickupDate) {
      activateCheckoutButton2();
      return true;
    }
    disableCheckoutButton2()
    return false;
}

function activateCheckoutButton2(){
  //console.log('Activate')
      document.querySelector('#checkout').disabled = false;
  }

function disableCheckoutButton2(){    
    document.querySelector('#checkout').disabled = true;
}

//_____________________________________________________________________________
document.addEventListener('crDeliveryActivated', function (e) {
  	//console.log('delivery activated')
    jqCR('#check_template--22526346953025__main-cart').click()
    var tt = setInterval(function(){disableCheckoutButton2();}, 1000);
    setTimeout(function() { clearInterval(tt); }, 2000);  
    

    jqCR(document).on('change', '#delivery-date-start', function(){
      setTimeout(function(){
      console.log('check');checkDeliveryFields()
      }, 400)
      
      
    })  
    trackChange(jqCR("#delivery-date-start")[0] );    
  
    var checkExist = setInterval(function() {
            if (typeof crdebug !== 'undefined') console.log('§ Checking §')
			var isDelivery = jqCR('.cr-delivery-button').hasClass('selected')
            var deliveryZip = jqCR('#cr-delivery-zip').val()
            var deliveryTime = jqCR('.cr-delivery-datepicker').val();
            //console.log({isDelivery, deliveryZip, deliveryTime})
            if (isDelivery === true) {
              if (deliveryZip === '' || deliveryTime === '') {
                disableCheckoutButton2();
              } else {
                activateCheckoutButton2();
//                console.log('Clear')
//              	clearInterval(checkExist);
              }
            }           
	}, 100);
})

function checkDeliveryFields(){
  	var deliveryDate = jqCR('#delivery-date-start').val()
    var deliveryTime = jqCR('#cr-delivery-time').val()
  
    if (deliveryDate && deliveryTime) {
    	activateCheckoutButton2();
    } else {
    	disableCheckoutButton2()
    }
}

var crDeliveryDateCallback = function(picker, blackoutdatesCollection){
  //blackoutdatesCollection.push([2025, 4, 11, 'inverted']);
  blackoutdatesCollection.push([2026, 4, 10, 'inverted']);
  blackoutdatesCollection.push([2026, 2, 8, 'inverted']);
  picker.set('disable', blackoutdatesCollection);
  //picker.set('min', 1);  
  if (currentDay === 8 && currentMonth === 2 && currentyear === 2026 && currentHour >= 13) {
    picker.set('min', 1);   
  }
}

var crDateCallback = function(picker, selectedStore, blackoutdatesCollection){  
  blackoutdatesCollection.push([2026, 4, 10, 'inverted']);
  //blackoutdatesCollection.push([2026, 2, 8, 'inverted']);
  picker.set('disable', blackoutdatesCollection);
  //picker.set('min', 1);  
}

var crPickupCallback = function(timepicker, selectedStore, selectedDay, selectedDate, selectedMonth) {
  if (!selectedStore) return;  
  if(selectedStore.storeID === 7826 && selectedDate.getDate() === 11 && selectedMonth === 4 && selectedDate.getFullYear() === 2025) {  	
    timepicker.set('min',[9, 0]); 
    timepicker.set('max',[14, 0]);
  }	

  // if(selectedDate.getDate() === 8 && selectedMonth === 2 && selectedDate.getFullYear() === 2026) {  	
  //   timepicker.set('min',[9, 0]); 
  //   timepicker.set('max',[12, 30]);
  // }	
}